import styled from "styled-components/macro";
import { Popper, Tooltip } from "@mui/material";
import { DeviceType } from "../../utils/hooks/useDeviceHook";

export const TestResultsCenterContainer = styled.div<{
  isRedrawParent: boolean;
}>`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr;
  min-width: 0;
  width: 100%;
  background-color: ${({ theme, isRedrawParent }) =>
    isRedrawParent ? theme.redrawParentGrey : theme.white};
  padding-bottom: 15px;
  border-radius: 24px;
`;

export const TestResultsOuterContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-gap: 5px;
  min-width: 0;
`;

export const TestResultsInnerContainer = styled.div<{ deviceType: DeviceType }>`
  display: grid;
  grid-template-columns: ${({ deviceType }) =>
    deviceType === "mobile" ? "minmax(0, 3fr) minmax(0, 6fr)" : "auto auto"};
  padding: 20px 20px 5px 20px;
  grid-gap: ${({ deviceType }) => (deviceType === "mobile" ? "" : "10px 20px")};
  min-width: 0;
`;

export const TestResultsRedrawWrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(0, auto) auto;
  grid-column-gap: 5px;
  min-width: 0;
`;

export const TestResultsInnerDesktopContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 10px;
`;

export const TestResultsInfoContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-gap: 10px;
  min-width: 0;
  padding: 15px 20px 5px 20px;
`;

export const TestResultsCfcContainer = styled.div`
  display: grid;
  grid-template-areas:
    "title status"
    "learn learn"
    "action action";
  grid-template-columns: minmax(0, 1fr) auto;
  column-gap: 8px;
  row-gap: 10px;
  align-items: center;
  min-width: 0;
  padding: 15px 20px 5px 20px;

  @media (min-width: 601px) {
    grid-template-areas:
      "title status action"
      "learn . .";
    grid-template-columns: auto auto minmax(0, 1fr);
    column-gap: 55px;
  }

  @media (min-width: 1201px) {
    padding: 5px 20px 0 25px;
  }
`;

export const TestResultsCfcTitle = styled.div`
  display: flex;
  align-items: center;
  grid-area: title;
  min-width: 0;
`;

export const TestResultsCfcStatus = styled.div`
  display: flex;
  align-items: center;
  grid-area: status;
  min-width: 0;
`;

export const TestResultsCfcLearnMore = styled.div`
  grid-area: learn;
`;

export const TestResultsCfcAction = styled.div`
  grid-area: action;
  display: flex;
  align-items: center;
  justify-self: end;
`;

export const TestResultsButtonContainer = styled.div<{
  deviceType: DeviceType;
  processing: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-end;
  justify-self: ${({ deviceType, processing }) =>
    deviceType !== "desktop" && processing
      ? "flex-start"
      : "flex-end"} !important;
  align-self: ${({ deviceType, processing }) =>
    deviceType !== "desktop" && processing
      ? "flex-start"
      : "flex-end"} !important;
  padding: 5px 20px 5px 20px;
`;

export const TestResultsViewAction = styled.div`
  align-items: center;
  align-self: flex-end;
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 100%;
  width: max-content;
`;

export const TestResultsFetalSexWarning = styled.div`
  align-items: center;
  display: flex;
  gap: 6px;
  justify-content: center;
  max-width: 100%;

  svg {
    flex: none;
    height: auto;
    width: 16px;
  }

  p {
    line-height: 20px;
  }
`;

export const TestResultsLearnMoreContainer = styled.div<{
  deviceType: DeviceType;
}>`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-gap: 10px;
  min-width: 0;
  p {
    padding: 0px 0px 0px
      ${({ deviceType }) => (deviceType === "mobile" ? "20px" : "25px")} !important;
  }
`;

export const TestResultsWatchVideoContainer = styled.span`
  display: inline-flex;
  align-items: center;

  svg {
    margin-left: 5px;
  }
`;

export const TestResultIconAndTypography = styled.div`
  display: inline-grid;
  grid-template-columns: 25px minmax(0, auto);
  grid-gap: 10px;
  align-items: center;
  min-width: 0;
`;

export const TestResultsIcon = styled.div<{
  marginLeft?: boolean;
}>`
  margin-left: ${({ marginLeft }) => marginLeft && "3px"};
`;

export const TestResultsHr = styled.hr`
  border: 1px solid ${({ theme }) => theme.neutral100};
  margin: 10px 0px;
`;

export const TestResultsDesktopContainer = styled.div`
  display: inline-grid;
  grid-template-columns: auto auto auto 1fr;
  grid-gap: 33px;
  padding: 18px 0px 0px 25px;
`;

export const TestResultsRiskDesktopContainer = styled.div`
  display: inline-grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 10px;
  padding: 5px 20px 0px 25px;
  align-items: center;
`;

export const TestResultsInfoDesktopContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 10px;
  padding: 20px 20px 0px 25px;
`;

export const TestResultsViewButton = styled.button<{ deviceType: DeviceType }>`
  background: ${({ theme }) => theme.redMedium};
  border-radius: 30px;
  border: none;
  margin: 0;
  color: ${({ theme }) => theme.white};
  padding: 5px 16px;
  font-size: 15px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  height: 32px;
  cursor: pointer;

  :hover {
    opacity: ${({ deviceType }) =>
      deviceType === "desktop" ? ".9" : undefined};
    box-shadow: ${({ deviceType }) =>
      deviceType === "desktop" ? "0px 2px 3px rgba(0, 0, 0, 0.3);" : undefined};
  }
`;

export const TestResultsTooltipContent = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  width: 100%;
  padding: 5px 5px;
  color: ${({ theme }) => theme.greyDark} !important;
  background-color: ${({ theme }) => theme.white} !important;
`;

export const TestResultsTooltip = styled(Tooltip)`
  margin-top: -15px;
  display: inline;
  justify-content: end;
`;

export const TestResultsTooltipPopper = styled(Popper)`
  .MuiTooltip-tooltip {
    background-color: white !important;
    box-shadow: 0px 10px 20px rgb(0 0 0 / 10%) !important;
    border-radius: 8px !important;
    font-family: "light";
    margin-top: 5px !important;
  }
  .MuiTooltip-arrow {
    color: white !important;
  }
`;

export const TestResultsPartialBanner = styled.div`
  display: flex;
  align-items: flex-start;
  background-color: ${({ theme }) => theme.blueSubtle};
  border-radius: 8px;
  padding: 12px 16px;
  margin: 8px 20px;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: ${({ theme }) => theme.blueDarker};
  gap: 8px;
`;

export const TestResultsMultipleReqMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  text-align: left;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  svg {
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 18px;
  }
  padding-left: 10px;
`;
